<template>

<div>

    <p>
        За да качиш, може да завлачиш избраните файлове и да ги поставиш в правоъгълника, по-долу или просто да натиснеш 'Избери файлове'.<br>
        <small>{{ alowedText }}</small>
    </p>

    <div class="dropzone text-center upload-image"
          :id="dzid">
          <span class="icon icon-upload-cloud d-block mt-5"></span>
    </div>

</div>

</template>

<script>
    export default {

        mounted() {
            var me = this;

            me.dropzone =  new this._dz("#" + this.dzid , this.config );

            me.dropzone.on('success', (r) => {
                
                var response = r.xhr.response;

                if( typeof response == 'string' ) {
                    response = JSON.parse( response );
                }

                if( response.status == 'success' ) {
                
                    me.$emit( 'upload-success', response.data );
                
                } else {
                    
                    $.notify("Възникна проблем с качването на файла",'warning');

                }

            })

            me.dropzone.on('error', ( msg ) => {
                $.notify('Възникна проблем с качването на файла','notify');
                console.log(msg);
            })
        },

        created() {

            if( typeof this.conf == 'object' ) {

                if( typeof this.conf.params == 'object' ) {
                    this.config.params = Object.assign( {}, this.config.params, this.conf.params );
                }


                if( typeof this.conf.id == 'string' ) {
                    this.dzid = this.conf.id;
                }

                if( typeof this.conf.alowedText == 'string' ) {
                    this.alowedText = this.conf.alowedText;
                }

                if( typeof this.conf.acceptFiles == 'object' ) {
                    this.config.acceptFiles = this.conf.acceptFiles;
                }

                if( typeof this.conf.url == 'string' ) {
                    this.config.url = this.conf.url;
                }
            }

        },

        props : ['conf'],

        data() {
            return {

                isReady : false,
                dzid    : 'default-dz',
                dropzone : false,

                alowedText : 'Разрешени формати: jpg, jpeg, png, dwg, pdf, xls, doc',

                config : { 

                    dictDefaultMessage : 'Избери файлове',

                    url         : "",
                    acceptFiles : ['image/*'],
                    params      : {
                        _token  : this.csrf
                    },

                    maxFilesize: 4.5,

                }

            }
        },

        methods : {

        }

    }
</script>
